module.exports = __webpack_public_path__ + "static/media/RW.6a96a7c9.png";